import UniqFinalPackingListRoutes from "./uniq_final_packing_list";
import BasicContainerExportRoutes from "./basic_container_export";
import QueryContainerExportRoutes from "./query_container_export";
import BasicContainerQualityRoutes from "./basic_container_quality";
import QueryContainerQualityRoutes from "./query_container_quality";
import QueryByProviderRoutes from "./query_by_provider";

export default [
  ...UniqFinalPackingListRoutes,
  ...BasicContainerExportRoutes,
  ...QueryContainerExportRoutes,
  ...BasicContainerQualityRoutes,
  ...QueryContainerQualityRoutes,
  ...QueryByProviderRoutes
];
